import { connect } from 'react-redux';
import { getSupportedTicketFormat } from '../../../selectors/ticketsAndEvent';

const _mapStateToProps = (state) => ({
    ticketsFormat: getSupportedTicketFormat(state),
});

const _mapDispatchToProps = (_dispatch) => ({});

export const connectTicketCategoryGroup = connect(
    _mapStateToProps,
    _mapDispatchToProps,
);
